export interface StatsCard {
  label: string
  count: number
  key: string
  isNavigable?: boolean
  linkToNavigate?: string
}

export const ACTIVITY_RECEIVED: StatsCard = {
  label: 'Activity Received',
  count: 0,
  key: 'RECEIVED'
}

export const IN_PROGRESS: StatsCard = {
  label: 'In Progress',
  count: 0,
  key: 'IN_PROGRESS'
}

export const QUERY_IN_PROGRESS: StatsCard = {
  ...IN_PROGRESS,
  isNavigable: true,
  linkToNavigate: '/query/summary?status=INP'
}

export const PENDING_WITH_ER: StatsCard = {
  label: 'Pending with ER',
  count: 0,
  key: 'PENDING_WITH_EMPLOYER'
}

export const PENDING_WITH_DEPARTMENT: StatsCard = {
  label: 'Pending with Department',
  count: 0,
  key: 'PENDING_WITH_DEPT'
}

export const PENDING_WITH_EE: StatsCard = {
  label: 'Pending with EE',
  count: 0,
  key: 'PENDING_WITH_EMPLOYEE'
}

export const COMPLETED: StatsCard = {
  label: 'Completed',
  count: 0,
  key: 'COMPLETED'
}

export const QUERY_COMPLETED: StatsCard = {
  ...COMPLETED,
  isNavigable: true,
  linkToNavigate: '/query/summary?status=COMPLETED'
}

export const QUERIES_RECEIVED: StatsCard = {
  label: 'Queries Received',
  count: 0,
  key: 'RECEIVED',
  isNavigable: true,
  linkToNavigate: '/query/summary?status=QR'
}

export const TASK_INITIATED: StatsCard = {
  label: 'Tasks Initiated',
  count: 0,
  key: 'TASK_INITIATED'
}

export const WAITING_ON_CLIENT: StatsCard = {
  label: 'Waiting on Client',
  count: 0,
  key: 'WAITING_ON_CLIENT'
}

export const DRAFT_AWAITING_SIGNATURE: StatsCard = {
  label: 'Draft Awaiting Signature',
  count: 0,
  key: 'Draft_AWAITING_SIGNATURE'
}

export const WAITING_ON_DRAFT: StatsCard = {
  label: 'Waiting on Draft',
  count: 0,
  key: 'WAITING_ON_DRAFT'
}

export const SUBMITTED: StatsCard = {
  label: 'Submitted',
  count: 0,
  key: 'SUBMITTED'
}

export const DRAFT_UNDER_REVIEW: StatsCard = {
  label: 'Draft Under Review',
  count: 0,
  key: 'DRAFT_UNDER_REVIEW'
}
export const CASE_CLOSED: StatsCard = {
  label: 'Case Closed',
  count: 0,
  key: 'CASE_CLOSED'
}
